import { __extends, __spreadArray } from "tslib";
import * as React from 'react';
import * as _ from 'lodash';
import { ColorSample } from './ColorSample/ColorSample';
import styles from './ColorSampleGroup.scss';
import classNames from 'classnames';
export var DataHook;
(function (DataHook) {
    DataHook["colorGroup"] = "colorGroup";
})(DataHook || (DataHook = {}));
var ColorSampleGroup = /** @class */ (function (_super) {
    __extends(ColorSampleGroup, _super);
    function ColorSampleGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelect = function (option) {
            var selected;
            var _a = _this.props, allowMultiple = _a.allowMultiple, prevSelected = _a.selected;
            if (allowMultiple || _this.isSelected(option)) {
                if (_this.isSelected(option)) {
                    selected = prevSelected.filter(function (s) { return s.id !== option.id; });
                }
                else {
                    selected = __spreadArray(__spreadArray([], prevSelected, true), [option], false);
                }
            }
            else {
                selected = [option];
            }
            if (_this.props.onSelect) {
                _this.props.onSelect(selected);
            }
        };
        _this.onKeyboardArrowEvent = function (direction, offset) {
            if (offset === void 0) { offset = 0; }
            var _a = _this.props, options = _a.options, isRTL = _a.isRTL;
            var currentFocus = _this.state.currentFocus;
            var directionWithRTL = direction * (isRTL ? -1 : 1);
            var nextFocus = currentFocus + directionWithRTL + offset;
            if (nextFocus >= options.length) {
                nextFocus = 0;
            }
            if (nextFocus === -1) {
                nextFocus = options.length - 1;
            }
            if (options[nextFocus].isDisabled) {
                return _this.onKeyboardArrowEvent(direction, offset + directionWithRTL);
            }
            _this.setState({ currentFocus: nextFocus });
        };
        _this.isOptionVisible = function (option) {
            return option.isVisible !== false;
        };
        _this.state = {
            currentFocus: 0,
        };
        return _this;
    }
    ColorSampleGroup.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, options = _b.options, onMouseEnter = _b.onMouseEnter, onMouseLeave = _b.onMouseLeave, colorSampleClassName = _b.colorSampleClassName, shouldFocus = _b.shouldFocus, colorGroupClassName = _b.colorGroupClassName, allowMultiple = _b.allowMultiple, withTabIndexExperiment = _b.withTabIndexExperiment;
        var currentFocus = this.state.currentFocus;
        var colorGroupClasses = classNames([styles.colorSampleList, colorGroupClassName]);
        var isAnyColorSelected = !!((_a = this.props.selected) === null || _a === void 0 ? void 0 : _a.length);
        return (React.createElement("ul", { className: colorGroupClasses, "data-hook": DataHook.colorGroup }, options.filter(this.isOptionVisible).map(function (option, i) {
            return (React.createElement("li", { key: "color-".concat(i) },
                React.createElement(ColorSample, { description: option.description, isDisabled: option.isDisabled, isFirst: i === 0, isFocused: currentFocus === i, isSelected: _this.isSelected(option), onChange: function () { return _this.onSelect(option); }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: function () { return _this.setState({ currentFocus: i }); }, onKeyboardArrowEvent: _this.onKeyboardArrowEvent, rgbColorValue: option.value, colorSampleClassName: colorSampleClassName, shouldFocus: shouldFocus, allowMultiple: allowMultiple, isAnyColorSelected: isAnyColorSelected, withTabIndexExperiment: withTabIndexExperiment })));
        })));
    };
    ColorSampleGroup.prototype.isSelected = function (option) {
        return _.some(this.props.selected, function (s) { return s.id === option.id; });
    };
    ColorSampleGroup.defaultProps = {
        allowMultiple: false,
        isRTL: false,
        shouldFocus: true,
    };
    return ColorSampleGroup;
}(React.Component));
export { ColorSampleGroup };
//# sourceMappingURL=ColorSampleGroup.js.map